const data=[
    {
    id:1,
    ques:"React is a ?",
    a:"Framework",
    b:"Lybrary",
    c:"Both",
    d:"none of these"
},
{
    id:2,
    ques:"How many types of componenet",
    a:"two",
    b:"four",
    c:"Three",
    d:"seven"
},
{
    id:3,
    ques:"Hooks was introduced in version",
    a:"16.8",
    b:"25.4",
    c:"15.6",
    d:"9.0"
},
{
    id:4,
    ques:"useContext is perfect for ?",
    a:"small website",
    b:"large",
    c:"Both",
    d:"None of these"
},



]

export default data